import { useEffect } from 'react';

let pending = 0;
function warn(event: BeforeUnloadEvent) {
  event.preventDefault();
  event.returnValue = '';
}

/** Register actual local work, rather than every background network request. */
export function beginUnsavedChange() {
  if (pending++ === 0) window.addEventListener('beforeunload', warn);
  let active = true;
  return () => {
    if (!active) return;
    active = false;
    if (--pending === 0) window.removeEventListener('beforeunload', warn);
  };
}

export async function trackUnsavedChange<T>(operation: () => Promise<T>): Promise<T> {
  const finish = beginUnsavedChange();
  try {
    return await operation();
  } finally {
    finish();
  }
}

export function useUnsavedChanges(unsaved: boolean) {
  useEffect(() => {
    if (unsaved) return beginUnsavedChange();
  }, [unsaved]);
}
